export const URI = process.env.VUE_APP_SERVER_URI;
export const URI_REPORT = process.env.VUE_APP_SERVER_URI_REPORT;
export const URI_TARIFF_PLAN = process.env.VUE_APP_SERVER_URI_TARIFF_PLAN;
export const URI_ACCOUNTING_CASH =
  process.env.VUE_APP_SERVER_URI_ACCOUNTING_CASH;
export const URI_FINANCIAL_ACCOUNT =
  process.env.VUE_APP_SERVER_URI_FINANCIAL_ACCOUNT;
export const URI_GUARD_REQUEST = process.env.VUE_APP_SERVER_URI_GUARD_REQUEST;
export const URI_MESSAGES_SERVICE = process.env.VUE_APP_URI_MESSAGES_SERVICE;

export const URI_ORIANA = process.env.VUE_APP_SERVER_URI_ORIANA;
export const URI_VEHICLE_SCAN = process.env.VUE_APP_SERVER_URI_VEHICLE_SCAN;

export const GOOGLE_API_KEY = 'AIzaSyCSjZh01QLWTFDrEqJoe2tHlXJ8szYlFR4';

export const URI_EMPRO_REGISTER_VEHICLE = 'https://gestaohmlg.riopreto.sp.gov.br/empro_gestao_municipal/sjriopreto/empro_area_azul.php/api/peaceparking/placa';
export const URI_EMPRO_REGISTER_PHOTO = 'https://gestaohmlg.riopreto.sp.gov.br/empro_gestao_municipal/sjriopreto/empro_area_azul.php/api/peaceparking/foto';
export const EMPRO_APP = 'estacione-digital';
export const EMPRO_KEY = 'FNw776NvSQYhYAOCOuj6TYyhREVruQBzi4CLricK9WGdZd3emcL4zmRoh6MrOaCbx8eMZTdTbl6Iurm9fIjfKWNLmsI0FFl5J0Dq6ExxurJvdQHUlYdNAUGEF9bQN63XB8CrmumyQpiJsHrXQPoO28hsth7xS1XQgTw8IjRbVbK3A781tV8LXXgnjIE3DZrijALW3QtnVssDGqgSWspq8wltMNnHCO3kSULViMp8PvY2hvCSxUzcfTlf5wjiGijY';

export const MESSAGES_EVENTS = {
  PRIVATE_MESSAGE: 'private message',
  CONSUMER_PRIVATE_MESSAGE: 'consumer private message',
  READ_MONITOR: 'read monitor',
  READ_CONSUMER: 'read consumer',
  NEW_MONITOR_MESSAGE: 'new message',
  NEW_CONSUMER_MESSAGE: 'new consumer message',
  REMOTE_CONFIG: 'remote config',
  REFRESH_MONITORS: 'refresh monitors',
};
export const REMOTE_CONFIG = {
  KIOSK_MODE: 'kiosk-mode',
  TICKET_PRINT: 'ticket-print',
  LOGOUT: 'logout',
  PHOTO_REQUEST: 'photo request',
};
